import { createContext } from 'react';

export const modalContext = createContext({});
export const ModalContextProvider = modalContext.Provider;
export const ModalContextConsumer = modalContext.Consumer;
